import { useContext, useEffect, useState } from "react";
import { getCustomisationValue } from "../../../EditablePreview/EditablePreview";
import { changeNumericalFieldValue, changeStringFieldValue } from "../../ModuleList";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import ModuleTextInput from "../../components/ModuleTextInput";
import { ShowColorPicker } from "../../../../../../forms/ColorPicker/ColorPickerPopUp";
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";
import { COLOUR_NAME_TO_COLOUR_HEX } from "../../../../../../../helpers/Colours";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";

const BorderModule = (props) => {
    const { moduleConfig, customisationVars } = props;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    
    let colorFieldConfig = null;
    let opacityFieldConfig = null;
    let positionFieldConfig = null;
    let thicknessFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('border-color')) {
            colorFieldConfig = field;
        } else if (field.field.includes('border-opacity')) {
            opacityFieldConfig = field;
        } else if (field.field.includes('border-position')) {
            positionFieldConfig = field;
        } else if (field.field.includes('border-thickness')) {
            thicknessFieldConfig = field;
        }
    }

    const [color, setColor] = useState(getCustomisationValue(customisationVars, colorFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '#000000');
    const [opacity, setOpacity] = useState(getCustomisationValue(customisationVars, opacityFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '100');
    const [position, setPosition] = useState('Inside'); // Ignoring positionFieldConfig for now
    const [thickness, setThickness] = useState(getCustomisationValue(customisationVars, thicknessFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '0');
    useEffect(() => {
        if (colorFieldConfig?.dataLink) {
            const colorValue = getCustomisationValue(customisationVars, colorFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setColor(colorValue ?? '#000000');
        } else {
            setColor('#000000');
        }
        if (opacityFieldConfig?.dataLink) {
            const opacityValue = getCustomisationValue(customisationVars, opacityFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setOpacity(opacityValue ?? '100');
        } else {
            setOpacity('100');
        }
        if (thicknessFieldConfig?.dataLink) {
            const thicknessValue = getCustomisationValue(customisationVars, thicknessFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setThickness(thicknessValue ?? '0');
        } else {
            setThickness('0');
        }
    }, [moduleConfig, customisationVars, colorFieldConfig, opacityFieldConfig, thicknessFieldConfig, props.forceUpdate]);

    const changeColorFieldValue = (value) => {
        if (colorFieldConfig) {
            if (changeStringFieldValue(customisationVars, colorFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setColor(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    const changeOpacityFieldValue = (value) => {
        if (opacityFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, opacityFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setOpacity(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    const changeThicknessFieldValue = (value) => {
        if (thicknessFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, thicknessFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setThickness(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Border</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Color</div>
                    <ModuleTextInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: COLOUR_NAME_TO_COLOUR_HEX(color, campaignContext.campaignData)}} />}
                        value={color}
                        fieldId={'border-color'}
                        enabled={true}
                        editable={false}
                        onChange={null}
                        onClick={() => {ShowColorPicker(color, changeColorFieldValue, campaignContext.campaignData, 'Border Color', () => {}, () => {})}}
                        maxLength={7}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Opacity</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{opacity: opacity / 100}} />}
                        value={opacity}
                        fieldId={'border-opacity'}
                        enabled={!!opacityFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeOpacityFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    />
                </div>
            </div>
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Position</div>
                    <ModuleTextInput
                        // fieldLabel=">"
                        value={position}
                        fieldId={'border-position'}
                        enabled={false}
                        onChange={null} // Ignoring position changes for now
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[{label: 'Inside', value: 'inside'}, {label: 'Outside', value: 'outside'}]}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Thickness</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{height: thickness}} />}
                        value={thickness}
                        fieldId={'border-thickness'}
                        enabled={!!thicknessFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeThicknessFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    />
                </div>
            </div>

            {renderSecondCustomBlock(props)}
        </div>
    );
}

export default BorderModule;
